<script lang="ts">
  import Modal from './Modal.svelte';
  import { ageGatingConfig } from '$lib/components/Games/config';
  import { PersistentStore } from '$lib/utils/persistent-store';
  import {
    adPrivacySettings,
    modalStore,
    redirectUrlStore,
    selectedAgeGroupStore
  } from '$lib/store';
  import Logger from '$lib/utils/logger';
  import { AGE_GATING_AGE_GROUP, CHILD_DIRECTED_TREATMENT } from '$lib/constants/persistent-store';
  import { setPrivacySettingsAndrefreshAds } from '../AdSlot/GoogleAdComponent';
  import { redirectTo, setCookie } from '$lib/utils';

  export let showModal = false;
  Logger.log('showModal', showModal);
  let countryCode = 'us';

  let ageGroups: { label: string }[] =
    (ageGatingConfig && ageGatingConfig?.[countryCode]?.['ageGroup']) ?? [];
  Logger.log('ageGroups', ageGroups);
  $: isDisabled = selectedAgeGroupStore.set('');
  $: selectedAgeGroup = $selectedAgeGroupStore;

  //   onMount(() => {
  //     if (browser) {
  //       showModal =
  //         ageGatingConfig?.[countryCode]?.showAgeGating &&
  //         PersistentStore.get(AGE_GATING_AGE_GROUP) === null;

  //         console.log('showModal in onMount', showModal);
  //     }
  //   });

  function handleClick() {
    Logger.log('Age gating button clicked', selectedAgeGroup);
    if (selectedAgeGroup) {
      PersistentStore.set(AGE_GATING_AGE_GROUP, selectedAgeGroup);

      const isChild = selectedAgeGroup === ageGroups[0]?.label;

      adPrivacySettings.set({ childDirectedTreatment: isChild });
      PersistentStore.set(CHILD_DIRECTED_TREATMENT, isChild);
      setPrivacySettingsAndrefreshAds(isChild);
      setCookie('disableCookies', isChild.toString());
      redirectTo($redirectUrlStore);

      Logger.log('Privacy settings updated', { isChild });
      modalStore.set({ isOpen: false });
    }
  }

  function selectAgeGroup(ageGroup: string) {
    selectedAgeGroup = ageGroup;
  }
</script>

<Modal {showModal}>
  <div class="modal">
    <div class="container">
      <p>Select your age group</p>
      <div class="age-groups">
        {#each ageGroups as ageGroup}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <!-- svelte-ignore a11y-no-static-element-interactions -->
          <div
            class="age-group {selectedAgeGroup === ageGroup?.label ? 'selected' : ''}"
            on:click={() => selectAgeGroup(ageGroup?.label)}
          >
            <!-- Actual radio button hidden -->
            <input
              type="radio"
              name="age-group"
              value={ageGroup?.label}
              checked={selectedAgeGroup === ageGroup?.label}
            />

            <!-- Label and custom radio container -->
            <span class="label">{ageGroup?.label}</span>
            <div class="radio-container {selectedAgeGroup === ageGroup?.label ? 'checked' : ''}" />
          </div>
        {/each}
      </div>
      <button
        class="instant-play"
        on:click={handleClick}
        disabled={isDisabled}
        style="background: {isDisabled ? '#767A82' : '#FFF'}">Continue</button
      >

      <div class="terms">
        By clicking continue, I accept the <a href="/terms-of-service"><u>Terms of Usage</u></a>
        {#if !(selectedAgeGroup === ageGroups[0]?.label)}
          & <a href="/privacy-policy"><u>Privacy Policy</u></a>
        {/if}
      </div>
    </div>
  </div>
</Modal>

<style lang="scss">
  .modal {
    text-align: center;
    width: 100%;
    background-color: #292f3b;
    &::-webkit-scrollbar {
      display: none;
    }
    position: absolute;
    border-radius: 15px 15px 0 0;
    bottom: 0;
    margin: 0 auto;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .instant-play {
      padding: 9px 24px;
      border-radius: 20px;
      background: #767a82;
      border: none;
      cursor: pointer;
      width: 90%;
    }
    p {
      color: #fff;
      text-align: center;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 29.665px;
    }
    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px 20px;
      color: white;
      justify-content: center;
      font-family: Arial, sans-serif;
      width: 100%;
    }

    .age-groups {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
      width: 90%;
      margin-bottom: 20px;
    }

    .age-group {
      padding: 25px 15px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 24px;
      position: relative;
      border-radius: 16px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      background: rgba(255, 255, 255, 0.1);
      .label {
        font-size: 20px;
        font-weight: 600;
        vertical-align: -webkit-baseline-middle;
        text-align: center;
        display: inline;
      }
    }

    .age-group.selected {
      &:focus-visible,
      &:visited,
      &:active,
      &:focus {
        clip-path: inset(0 round 16px);
      }
    }

    /* New radio button styles */
    input[type='radio'] {
      position: absolute;
      opacity: 0;
      pointer-events: none;
    }

    .radio-container {
      position: absolute;
      top: 6px;

      right: 8px;
      width: 16px;
      height: 16px;
      border: 2px solid rgba(255, 255, 255, 0.6);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: border-color 0.3s ease;
    }

    .radio-container.checked {
      background-color: #fff;
    }

    .radio-container.checked::after {
      content: '✔';
      color: #000;
      font-size: 14px;
    }

    button {
      background-color: #b19bce;
      color: #000;
      border: none;
      padding: 16px 32px;
      border-radius: 12px;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s ease;
    }

    button:hover {
      background-color: #9e88c0;
    }

    .terms {
      margin-top: 12px;
      font-size: 12px;
      color: #fbfbfb;
    }

    .terms a {
      color: #fbfbfb;
      text-decoration: none;
    }

    .terms a:hover {
      text-decoration: underline;
    }
  }
</style>
